import { Button } from "antd"
import React, { useMemo } from "react"
import { MultiSelectItem, MultiSelectProps, MultiSelectSelectMode } from "../MultiSelect"

type Props<TValue> = {
    filteredFlatData: MultiSelectItem<TValue>[]
    selectMode: MultiSelectSelectMode
    selectedIds: TValue[]
    setSelectedIds: (selectedIds: TValue[]) => void
    onApply: () => void
    onCancel: () => void
    renderActionButtons: MultiSelectProps["renderActionButtons"]
}
export const MultiSelectBottomButtons = <TValue extends string>({
    onApply,
    onCancel,
    selectMode,
    filteredFlatData,
    selectedIds,
    setSelectedIds,
    renderActionButtons,
}: Props<TValue>) => {
    const areAllItemsSelected = useMemo(() => {
        if (selectMode === MultiSelectSelectMode.ItemsOnly) {
            // Check whether all items (without children) in are selected
            return !filteredFlatData.filter(d => !d.children).some(data => !selectedIds.includes(data.id))
        }

        // Check whether all items (with and without children) are selected
        return !filteredFlatData.some(data => !selectedIds.includes(data.id))
    }, [filteredFlatData, selectMode, selectedIds])

    const onDeselectAll = () => {
        setSelectedIds([])
    }

    const onSelectAll = () => {
        if (selectMode === MultiSelectSelectMode.ItemsOnly) {
            setSelectedIds(filteredFlatData.filter(d => !d.children).map(d => d.id))
        } else {
            setSelectedIds(filteredFlatData.map(d => d.id))
        }
    }

    if (renderActionButtons) {
        return <div className={classes.buttonsWrap}>{renderActionButtons(onApply, onCancel, selectedIds)}</div>
    }

    return (
        <div className={classes.buttonsWrap}>
            <div className={classes.buttonsWrap2}>
                <Button className="flex-1" type="primary" onClick={onApply}>
                    Apply
                </Button>
                {areAllItemsSelected ? (
                    <Button className="flex-1" onClick={onDeselectAll}>
                        Deselect All
                    </Button>
                ) : (
                    <Button className="flex-1" onClick={onSelectAll}>
                        Select All
                    </Button>
                )}
            </div>
        </div>
    )
}
const classes = {
    buttonsWrap: "border-t border-gray-200",
    buttonsWrap2: "flex space-x-2 px-2 pt-2",
}
